// Idea show: "Invite and send message" card (#ideaManageInviteToggle / #ideaManageInviteSection).
// Imperative toggle: reliable with Turbolinks + webpack.

import { Collapse } from 'bootstrap'

function onIdeaManageInviteClick (e) {
  const btn = e.target && e.target.closest && e.target.closest('#ideaManageInviteToggle')
  if (!btn) return
  const panel = document.getElementById('ideaManageInviteSection')
  if (!panel) return
  e.preventDefault()
  e.stopPropagation()
  Collapse.getOrCreateInstance(panel, { toggle: false }).toggle()
}

function syncIdeaManageInviteAria (e) {
  if (!e.target || e.target.id !== 'ideaManageInviteSection') return
  const btn = document.getElementById('ideaManageInviteToggle')
  if (!btn) return
  btn.setAttribute('aria-expanded', e.target.classList.contains('show') ? 'true' : 'false')
}

document.addEventListener('click', onIdeaManageInviteClick)
document.addEventListener('shown.bs.collapse', syncIdeaManageInviteAria)
document.addEventListener('hidden.bs.collapse', syncIdeaManageInviteAria)
